import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrushingGrindingMachine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 60,
	viewBox: "0 0 100.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 100.0 0.0 L 80.0 60.0 L 20.0 60.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 30.0 10.0 L 70.0 50.0 M 70.0 10.0 L 30.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgCrushingGrindingMachine;
